module.exports = __webpack_public_path__ + "static/media/st-emilion.e50a13e1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/st-emilion.jpg
 ** module id = 411
 ** module chunks = 0
 **/